{
  "welcome": "Добро пожаловать в",
  "instructions": "Нажмите ниже, чтобы начать процесс регистрации.",
  "startCheckIn": "Начать регистрацию",
  "missingWarehouseTitle": "Склад не указан",
  "missingWarehouseMessage": "Ссылка недействительна: в ней должен быть указан ID склада",
  "recaptchaAttribution": "Этот сайт защищён reCAPTCHA. К нему применяются {privacyPolicy} и {termsOfService} Google.",
  "recaptchaPrivacyPolicy": "Политика конфиденциальности",
  "recaptchaTermsOfService": "Условия использования",
  "lookupTitle": "Добавьте референс-номер или номер подтверждения, чтобы найти свою запись",
  "referenceNumberLabel": "Референс-номер или номер подтверждения",
  "referenceNotFoundError": "Референс-номер или номер подтверждения не соответствует ни одной действительной записи.",
  "checkIn": "Зарегистрироваться",
  "loadTypeLabel": "Тип груза",
  "directionLabel": "Направление",
  "operationLabel": "Операция",
  "dockLabel": "Док",
  "orDivider": "или",
  "noReferenceTitle": "У меня нет номера подтверждения",
  "noReferenceDescription": "Продолжить без записи, используя стандартный процесс регистрации.",
  "checkInWithoutAppointment": "Зарегистрироваться без записи",
  "readyToCheckInTitle": "Готовы зарегистрироваться?",
  "readyToCheckInDescription": "Нажмите ниже, чтобы начать. Свои данные вы введёте на следующем экране.",
  "referenceRequiredHint": "Для регистрации на этом объекте требуется номер ссылки.",
  "haveAppointment": "У меня есть запись",
  "direction": {
    "inbound": "Входящий",
    "outbound": "Исходящий",
    "inOut": "Входящий и исходящий",
    "load": "Погрузка",
    "unload": "Разгрузка"
  },
  "operation": {
    "live": "Вживую",
    "drop": "Оставление",
    "other": "Другая"
  }
}
